import styled from 'styled-components';

export const StyledBold = styled.span`
  font-weight: ${props => props.theme.fontSemiBold};
`;
